import { Menu } from './Menu';
import { HelpButtonModal } from "./index";

import { useState, useEffect, useCallback } from 'react';

// Components

import Header from './Components-AppPage/Header';

// -- Redux ----------------------------------------------

import { useDispatch, useSelector } from 'react-redux';

// Dispatchers

// import { 
// 	fetchData
// } from '../store/dataStateReducers';

// Selectors
import { 
	getDataById
} from '../store/dataStateReducers';

import { 
	initActivityState,
	setSaveData,
	setItemsShowExplanation,
	setPostCompletionHTMLShow,
	setItemsShowCheckAnswer,
	getUidData,
	getPostCompletionHTMLShowBool
 } from "../store/activityStateReducers";

import { 
	CompText,
	CompTextarea,
	CompRadios,
	CompDropdown,
	CompAffective,
	CompCheckSeveral
 } from "./item_types/index";
import { CompHTML } from "./widgets/index";

// ----------------------------------------------------------

const help_html = '<div style="font-size:0.8em;line-height:1.25;"><h5>Help</h5> <p> When you type in a field or a text box, you can easily produce international characters such as ã or é by typing one of the key combinations in the table below. </p> <p> For example, when you type the combination e then ^, and activity will automatically convert that to ê. So, to type the word você, you would literally type the following: v o c e ^ </p> <p> On the left are the key combinations. To the right of each of them you will see the international character that the combination will produce. </p> <table class="table table-hover" style="line-height:0.85;"> <thead> <tr> <th scope="col">Key combination</th> <th scope="col"> International character</th> </tr> </thead> <tbody> <tr> <td>!!</td> <td>¡</td> </tr> <tr> <td>??</td> <td>¿</td> </tr> <tr> <td>a&apos;</td> <td>á</td> </tr> <tr> <td>a&grave;</td> <td>à</td> </tr> <tr> <td>a^</td> <td>â</td> </tr> <tr> <td>a~</td> <td>ã</td> </tr> <tr> <td>c&apos;</td> <td>ç</td> </tr> <tr> <td>e&apos;</td> <td>é</td> </tr> <tr> <td>e&grave;</td> <td>è</td> </tr> <tr> <td>e^</td> <td>ê</td> </tr> <tr> <td>i&apos;</td> <td>í</td> </tr> <tr> <td>i&grave;</td> <td>ì</td> </tr> <tr> <td>o&apos;</td> <td>ó</td> </tr> <tr> <td>o&grave;</td> <td>ò</td> </tr> <tr> <td>o^</td> <td>ô</td> </tr> <tr> <td>o~</td> <td>õ</td> </tr> <tr> <td>u&apos;</td> <td>ú</td> </tr> <tr> <td>u&grave;</td> <td>ù</td> </tr> <tr> <td>u&lt;</td> <td>ü</td> </tr> <tr> <td>n~</td> <td>ñ</td> </tr> </tbody> </table></div>';

export const ActivityPage = (props) => {



	const dispatch = useDispatch();
	
	const activity_data = useSelector( (state) => getDataById(state, "activity_data") );
	const activity_group = activity_data.data_js.activity_group;
	const activity = activity_data.data_js.activity;
	const note = activity_data.data_js.note;
	const {
		instant_feedback_bool,
		explanations_only_after_save_bool,
		description,
		items_a
	} = activity_data.data_js.uniq_activity_js;
	const { 
		app,
		uid,
		uniq,
		period
	} = activity_data.data_js;

	let post_completion_html = activity_data.data_js.uniq_activity_js.post_completion_html;
	if (post_completion_html === undefined) {
		post_completion_html = <></>;
	} else {
		post_completion_html = <CompHTML html={post_completion_html} />;
	}

	

	// ------ Is state.activityStates set up? --------
	const is_activities_state_set_bool = useSelector((state) => {
		let res;
		try {
			if (state.activityStates.init_complete_bool === true) {
				res = true;
			} else {
				res = false;
			}
		} catch (e) {
			res = false;
		}
		return res;
	});
	// -----------------------------------------------
	
	// ------  Save/submit, check answers, explanations ---------------------------
	
	const is_complete_bool = useSelector((state) => {
		return state.activityStates.items_incomplete_a.length > 0 ? false : true;
	});

	const [save_clicked_bool, setSaveClicked] = useState(false);
	const [save_success_bool, setSaveSuccess] = useState(false);
	const handleClick = (event) => {
		const action = event.target.getAttribute("data-action");
		console.log(action)
		if (action === "save") {
			setSaveSuccess(true);
		}
		if (action === "review") {
			setSavePermitted(show_items_js.save_option_bool);
			dispatch(setItemsShowExplanation({value: show_items_js.items_show_explanation_bool}));
			dispatch(setItemsShowCheckAnswer({value: show_items_js.items_show_checkanswer_bool}));
			dispatch(setPostCompletionHTMLShow({value: show_items_js.items_show_post_completion_bool}));
			setReviewClicked(true);
		}
	};

	const uid_data = useSelector( (state) => getUidData(state) );
	const post_completion_html_show_bool = useSelector( (state) => getPostCompletionHTMLShowBool(state) );

	const getData = useCallback( () => {	
		let data = Object.assign({},uid_data);
		data = JSON.stringify(data);
		const data_js = { 
			app,
			uid,
			uniq,
			period,
			data
		}
		return data_js;
	} , [ uid_data, app, uid, uniq, period ]);

	const [review_permitted_bool, setReviewPermitted] = useState(false);
	const [review_clicked_bool, setReviewClicked] = useState(false);
	const [save_permitted_bool, setSavePermitted] = useState(false);
	useEffect(() => {
		if (save_clicked_bool) {
// 			const data_js = getData();
// 			dispatch( fetchData({
// 				id: "responses_submit",
// 				script_uri: "php/responses_submit.php",
// 				data_js
// 			}));
			dispatch(setSaveData({saved_bool:true}));
			if (instant_feedback_bool && explanations_only_after_save_bool) {
				dispatch(setItemsShowCheckAnswer({value: true}));
				dispatch(setItemsShowExplanation({value: true}));
				dispatch(setPostCompletionHTMLShow({value: true}));
			}
			if (!instant_feedback_bool && explanations_only_after_save_bool) {
				dispatch(setItemsShowCheckAnswer({value: true}));
				dispatch(setItemsShowExplanation({value: true}));
				dispatch(setPostCompletionHTMLShow({value: true}));
			}
			setSaveClicked(false);
			setSavePermitted(false);
		}
	}, [save_clicked_bool, instant_feedback_bool, explanations_only_after_save_bool, getData, dispatch]);

	const [show_items_js, setShowItemJS] = useState(
		{
			ready_bool: false,
			save_option_bool: undefined,
			items_show_explanation_bool: undefined,
			items_show_checkanswer_bool: undefined,
			items_show_post_completion_bool: undefined
		}
	);
	useEffect(() => {
		if (is_activities_state_set_bool) {
			let this_save_option_bool = false;
			let this_items_show_explanation_bool = false;
			let this_items_show_checkanswer_bool = false;
			let this_items_show_post_completion_bool = false;

			if (is_complete_bool) {

				if (instant_feedback_bool && !explanations_only_after_save_bool) {
					this_save_option_bool = true;
					this_items_show_explanation_bool = true;
					this_items_show_checkanswer_bool = true;
					this_items_show_post_completion_bool = true;
				}

				if (instant_feedback_bool && explanations_only_after_save_bool) {
					this_save_option_bool = true;
				}

				if (!instant_feedback_bool && !explanations_only_after_save_bool) {
					this_items_show_explanation_bool = true;
					this_items_show_checkanswer_bool = true;
					this_items_show_post_completion_bool = true;
					this_save_option_bool = true;
				}

				if (!instant_feedback_bool && explanations_only_after_save_bool) {
					this_save_option_bool = true;
				}

				const js = {
					ready_bool: true,
					save_option_bool: this_save_option_bool,
					items_show_explanation_bool: this_items_show_explanation_bool,
					items_show_checkanswer_bool: this_items_show_checkanswer_bool,
					items_show_post_completion_bool: this_items_show_post_completion_bool
				}
				setShowItemJS(js);
			}
		}
	}, [
		is_activities_state_set_bool,
		instant_feedback_bool,
		explanations_only_after_save_bool,
		is_complete_bool,
		dispatch
	]);

	useEffect(()=>{
		if (show_items_js.ready_bool) {
			setReviewPermitted(true);
			setReviewClicked(false);
		} else {
			setSavePermitted(show_items_js.save_option_bool);
			dispatch(setItemsShowExplanation({value: show_items_js.items_show_explanation_bool}));
			dispatch(setItemsShowCheckAnswer({value: show_items_js.items_show_checkanswer_bool}));
			dispatch(setPostCompletionHTMLShow({value: show_items_js.items_show_post_completion_bool}));
		}
	},[show_items_js,review_permitted_bool,dispatch]);

	// -----------------------------------------------

	useEffect(() => {
		dispatch(initActivityState({ items_a }));
	}, [items_a, dispatch]);

	const getComponentsJSXArray = () => {
		let answer_index = 0;
		let comps_types_a = items_a.map((elem, i) => {

			const item_number = answer_index + 1;
			const props_js = Object.assign({}, elem);
			let jsx;

			if ( elem.definitions_js.type === "html" ) {
				jsx = (
					<CompHTML 
						html={elem.data_js.prompt_s}
						element_type='div'
						style_js={{marginTop: 20, marginLeft: -10}}
					/>
				);
			} else {
				switch (elem.definitions_js.type) {
				
					case "radios":
						jsx = (
							<CompRadios
								answer_index={answer_index}
								item_number={item_number}
								instant_feedback_bool={instant_feedback_bool}
								{...props_js}
							/>
						);
						break;
					
					case "dropdown":
						jsx = (
							<CompDropdown
								answer_index={answer_index}
								item_number={item_number}
								instant_feedback_bool={instant_feedback_bool}
								{...props_js}
							/>
						);
						break;
					
	
					case "text":
						jsx = (
							<CompText
								answer_index={answer_index}
								item_number={item_number}
								instant_feedback_bool={instant_feedback_bool}
								{...props_js}
							/>
						);
						break;
	
					case "textarea":
						jsx = (
							<CompTextarea
								answer_index={answer_index}
								item_number={item_number}
								instant_feedback_bool={instant_feedback_bool}
								{...props_js}
							/>
						);
						break;
	
					case "affective":
						jsx = (
							<CompAffective
								answer_index={answer_index}
								item_number={item_number}
								instant_feedback_bool={instant_feedback_bool}
								{...props_js}
							/>
						);
						break;
	
					case "check_several":
						jsx = (
							<CompCheckSeveral
								answer_index={answer_index}
								item_number={item_number}
								instant_feedback_bool={instant_feedback_bool}
								{...props_js}
							/>
						);
						break;
	
					default:
						jsx = <></>;
				}
				answer_index++;
			}

			return (
				<div
					className="activity_item_class"
					key={"activity_item_" + (i + 1)}
				>
					{jsx}
				</div>
			);

		});
		return comps_types_a;
	};

	const components_a_jsx = getComponentsJSXArray();

	const jsx = (
		<div
			style={{
				marginBottom:20,
				paddingBottom: 200
			}}
		>
			<div>
				<h5>Description:</h5>
				<CompHTML
					html={description}
					element_type="div"
					classname_s="activity_description_class"
				/>
			</div>
			<div
				style={{
					marginTop: 20,
					display: is_activities_state_set_bool ? "block" : "none"
				}}
			>
				{components_a_jsx}
				<button
					style={{
						marginTop: 30,
						display: review_permitted_bool && !review_clicked_bool ? "block" : "none",
						float: "right"
					}}
					className="btn btn-primary"
					data-action="review"
					onClick={handleClick}
				>
					Review
				</button>				
				<button
					style={{
						marginTop: 30,
						marginRight:30,
						display: save_permitted_bool ? "block" : "none",
						float: "right"
					}}
					className="btn btn-primary"
					data-action="save"
					onClick={handleClick}
				>
					Save
				</button>
				<div
					className="alert alert-success"
					role="alert"
					style={{
						marginTop: 30,
						marginRight: 100,
						display: save_success_bool ? "inline" : "none",
						float: "right",
						padding: 10
					}}
				>
					&#x2713; Answers recorded
				</div>
			</div>
			<div
				style={{
					marginTop: 30,
					display: post_completion_html_show_bool ? "inline" : "none",
					float: "left",
					padding: 10
				}}
			>
				{post_completion_html}
			</div>
		</div>
	);

	

	return (
		<>
			<Menu items={['selectAppPage','appPage','logOut']} />
			<Header />
			<p>{activity_group}</p>
			<p>Activity: {activity}</p>
			{ (note !== 'none') && <p>Note: {note}</p> }
			<hr />
			<HelpButtonModal 
				title="Help: Special characters"
				modal_html={help_html}
			/>
			<hr />
			<div>{jsx}</div>
		</>
	);
}